import { render, staticRenderFns } from "./theMostActiveClients.vue?vue&type=template&id=218cd4d1&"
import script from "./theMostActiveClients.vue?vue&type=script&lang=js&"
export * from "./theMostActiveClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports